module.exports = __webpack_public_path__ + "static/media/09_Maf_NuestroEquipo_NestrorRuiz.d67fa841-01 copia.42337628.png";